export default __webpack_public_path__ + "static/media/ocean.55b10a84.svg";